/** Next router query shape: a value may be missing, a string, or repeated. */
export type QueryLike = Record<string, string | string[] | undefined>;

/** `?debug=1` (or `true`) reveals fake-data and pending-API marks meant for developers only. */
export function isDebug(query: QueryLike): boolean {
  const raw = query.debug;
  const value = Array.isArray(raw) ? raw[0] : raw;
  return value === '1' || value === 'true';
}
